var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.affiliate)?_c('div',[(_vm.canBeLinked)?_c('a',{attrs:{"href":"javascript:"},on:{"click":_vm.goToProfile}},[_vm._v(" "+_vm._s(_vm.affiliate?.complete_name + (_vm.affiliate?.is_deceased ? ` ✝` : '') ?? '')+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.affiliate?.complete_name + (_vm.affiliate?.is_deceased ? ` ✝` : '') ?? '')+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }